import {
    FETCH_TEAMS_REQUEST,
    FETCH_TEAMS_SUCCESS,
    FETCH_TEAMS_FAILURE,
    ADD_TEAM_REQUEST,
    ADD_TEAM_SUCCESS,
    ADD_TEAM_FAILURE,
  } from '../../types';
  
  interface TeamState {
    teams: any[];
    loading: boolean;
    error: string | null;
    total: number;
    currentPage: number;
    totalPages: number;
  }
  
  const initialState: TeamState = {
    teams: [],
    loading: false,
    error: null,
    total: 0,
    currentPage: 1,
    totalPages: 1,
  };
  
  export const teamReducer = (
    state = initialState,
    action: any
  ): TeamState => {
    switch (action.type) {
      case FETCH_TEAMS_REQUEST:
      case ADD_TEAM_REQUEST:
        return {
          ...state,
          loading: true,
          error: null,
        };
      case FETCH_TEAMS_SUCCESS:
        return {
          ...state,
          loading: false,
          teams: action.payload.teams,
          total: action.payload.total,
          currentPage: action.payload.currentPage,
          totalPages: action.payload.totalPages,
        };
      case ADD_TEAM_SUCCESS:
        return {
          ...state,
          loading: false,
          teams: [...state.teams, action.payload],
        };
      case FETCH_TEAMS_FAILURE:
      case ADD_TEAM_FAILURE:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  